import { filterByDepartment } from "../filters/filterByDepartment";
import { GreenhouseDepartment } from "../types";

const getAvailableLocationNames = (departments: GreenhouseDepartment[], selectedDepartmentName: string) => {
  if (!departments?.length) {
    return [];
  }

  const availableDepartments = departments.filter(filterByDepartment(selectedDepartmentName));

  const locationNames = new Set<string>();

  availableDepartments.forEach((department) => {
    department?.jobs?.forEach((job) => locationNames.add(job.location.name));
  });

  const singleLocationNames = new Set(
    Array.from(locationNames)
      .map((locationName) => locationName.split("; "))
      .flat()
      .map((locationName) => locationName.trim())
  );

  return Array.from(singleLocationNames);
};

export { getAvailableLocationNames };
